import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact AMALIKA WORLD</h3>
          <p><i className="fas fa-map-marker-alt" aria-hidden="true"></i> 123 Innovation Boulevard, Tech City, TC 12345</p>
          <p><i className="fas fa-phone" aria-hidden="true"></i> +1 (555) 123-AMALIKA WORLD</p>
          <p><i className="fas fa-envelope" aria-hidden="true"></i> hello@amalikaschool.edu</p>
          <p><i className="fas fa-clock" aria-hidden="true"></i> Mon-Fri: 8:00 AM - 6:00 PM</p>
          <div className="social-icons">
            <a href="#" className="social-icon" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="social-icon" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-icon" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-icon" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <a href="#login">Student Portal</a>
          <a href="#login">Teacher Dashboard</a>
          <a href="#programs">Course Catalog</a>
          <a href="#about">About Us</a>
          <a href="#contact">Support Center</a>
        </div>
        
        <div className="footer-section">
          <h3>Our Programs</h3>
          <a href="#languages">Language Learning</a>
          <a href="#robotics">Robotics & Engineering</a>
          <a href="#programming">Programming & Coding</a>
          <a href="#">Workshops & Events</a>
        </div>
        
        <div className="footer-section">
          <h3>Resources</h3>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Accessibility</a>
          <a href="#">Technical Support</a>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} AMALIKA WORLD School. All rights reserved. Empowering minds across all generations.</p>
      </div>
    </footer>
  );
};

export default Footer;